import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, SortDescriptor, process, orderBy } from '@progress/kendo-data-query';
import { FilterPipe } from 'ngx-filter-pipe';
import { SaveAlumniDetaisService } from '../../../@services/alumni-application.service';


@Component({
  selector: 'ngx-modal',
  template: `
    <div class="modal-header">
      <span>{{ modalHeader }}</span>
      <button class="close" aria-label="Close" (click)="closeModal('close')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body"> 
      <div class="survey-box"   
      *ngFor="let item of gridData; let i = index;">
        <div class="survey-header">
          <div class="row">
            <div class="col-6"><p><b>Name:</b> {{ item.FirstName}} {{item.LastName}} {{item.MaidenName }} </p></div>
            <div class="col-4"><p><b>GraduatedDate:</b> {{ item.GraduatedDate | date: 'MM/y' }}</p></div> 
            <div (click)="expandClick(expand[i], item.AlumniID,i);" class="col-1 text-right">
              <p>
                <i [hidden]="expand[i]" class="fas fa-chevron-down"></i>
                <i [hidden]="!expand[i]" class="fas fa-chevron-right"></i>
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="item" class="survey-body" [ngClass]="{'show-box': expand[i]}">
          <div class="survey-header-details" *ngFor="let exitem of expandData[i]; let j = index;">
            <div class="row">
              <div class="col-6"><div class="row"><div class="col-6"><b>CurrentlyWork:</b></div> <div class="col-6 popup-padding">{{ exitem.CurrentlyWork}}</div></div></div>
              <div class="col-6"><div class="row"><div class="col-6"><b>City:</b></div> <div class="col-6 popup-padding"> {{ exitem.City}}</div></div></div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-6"><div class="row"><div class="col-6"><b>State:</b></div> <div class="col-6 popup-padding"> {{ exitem.State}}</div></div></div> 
              <div class="col-6"><div class="row"><div class="col-6"><b>What Is Specialty:</b></div> <div class="col-6 popup-padding"> {{ exitem.WhatIsSpecialty}}</div></div></div>
            </div>
            <hr/>
            <div class="row">
            <div class="col-6"><div class="row"><div class="col-6"><b>What Department Do You Work In:</b></div> <div class="col-6 popup-padding"> {{ exitem.WhatDepartmentdoyouworkin}}</div></div></div>
              <div class="col-6"><div class="row"><div class="col-6"><b>How Long You Work In Department:</b></div> <div class="col-6 popup-padding"> {{ exitem.HowLongYouWorkInDepartment}}</div></div></div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-6"><div class="row"><div class="col-6"><b>Are You Manager In Department:</b></div> <div class="col-6 popup-padding"> {{ exitem.AreYouManagerInDepartment}}</div></div></div>
              <div class="col-6"></div>
            </div>
            <hr style="border-color:black;"/>
          </div>
        </div>
      </div>
    <div class="modal-footer">
    <button class="btn btn--primary fr" size="small" style="color:white;" (click)="Ok()">Yes</button>
    <button class="btn btn--primary fr" size="small" style="color:white;" (click)="closeModal()">No</button>
    </div> 
  `,
  styleUrls: ['./../alumni-application.component.scss'],
})

export class OverwriteEntryConfirmationModalComponent {

  modalHeader: string;
  modaldata: any;
  public gridView: GridDataResult;
  public gridData: any[] = [];
  expand: any = [];
  expandData: any = [];

  public state: State = {
    skip: 0,
    take: 10
  };
  public sort: SortDescriptor[] = [{
    field: 'FirstName',
    dir: 'asc'
  }];

  constructor(private activeModal: NgbActiveModal, private filter: FilterPipe, public saveAlumniService: SaveAlumniDetaisService) {

  }

  ngOnInit() {
    this.gridData = this.modaldata;
    this.sortChange(this.sort);
    this.gridView = this.loadItems(this.gridData, this.state);
  }

  Ok() {
    this.activeModal.close('');
  }

  closeModal(data) {
    this.activeModal.dismiss(data);
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.gridView = {
      data: orderBy(this.gridData, sort),
      total: this.gridData.length
    };
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.gridData, this.state);
  }

  private loadItems(gridData: Array<any>, state: State): GridDataResult {
    let gridView: GridDataResult = {
      data: gridData.slice(state.skip, state.skip + state.take),
      total: gridData.length
    };
    return gridView;
  }

  private onSearch(searchStr: string) {
    let filter = { $or: [{ FirstName: searchStr }, { LastName: searchStr }] };
    let result = this.filter.transform(this.gridData, filter);
    this.gridView = this.loadItems(result, this.state);
  }

  expandClick(state, data, index) {
    if (state) {
      this.expand[index] = false;
    } else {
      this.expand[index] = true;

      this.saveAlumniService.getDetailsByAlumniID(data).subscribe((data) => {
        if (data.ServiceStatus == "SUCCESS") {
          this.expandData[index] = data.DepartmentList;
        }
      });
    }
  }
}
